import type { Role } from "@/types/api";

export interface CognitoTokens {
  idToken: string;
  accessToken: string;
  refreshToken: string;
  /** Epoch ms when the ID token expires. */
  expiresAt: number;
}

/** Decoded claims this app reads from the ID token. */
export interface IdTokenClaims {
  sub: string;
  "cognito:username": string;
  "cognito:groups"?: string[];
  email?: string;
  email_verified?: boolean;
  phone_number?: string;
  phone_number_verified?: boolean;
  given_name?: string;
  family_name?: string;
  exp: number;
}

export function primaryRole(claims: IdTokenClaims): Role | null {
  const groups = claims["cognito:groups"] ?? [];
  const order: Role[] = ["ADMIN", "LIBRARIAN", "TEACHER", "STUDENT"];
  return order.find((role) => groups.includes(role)) ?? null;
}

export type AuthChallenge = "NEW_PASSWORD_REQUIRED";

export class CognitoError extends Error {
  readonly code: string;
  constructor(code: string, message: string) {
    super(message);
    this.code = code;
  }
}
